import { ReactElement } from 'react'
import styles from '../styles/StageContent.module.css'

interface Props {
  illustration: any,
  children: ReactElement[]
}

const StageContent = ({ illustration, children }: Props): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.illustration}>
        <img src={illustration} alt='Stage illustration' />
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  )
}

export default StageContent
